import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BoundaryCustomizeMetricsContainer, type BoundaryCustomizeMetricsContainerProps,
} from './boundaryCustomizeMetrics.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryCustomizeMetrics: BoundaryCustomizeMetricsContainerProps;
  }
}
modalRenderer.register('BoundaryCustomizeMetrics', BoundaryCustomizeMetricsContainer);
